import React from "react";
import BoardTabPane from "../common/BoardTabPane";
import { GRID_KEYS, TOP_TABS } from "../constants";
import { getCurrentDispatchObjectsStore } from "../services/DispatchManagementService";

/**
 * Current tab - dispatch objects scoped by the profile's CURRENTTABDATA (Delphi
 * tabTopCurrentDispatch, caption "&Current", over uFMM0058).
 *
 * Two things are specific to this tab: its query alone selects the trip columns, so it passes
 * showTripColumns; and its colouring is gated on CURRENTTABCOLORS, which rowColoring.js applies.
 */
const CurrentTab = (props) => (
    <BoardTabPane
        {...props}
        topTab={TOP_TABS.CURRENT}
        gridKey={GRID_KEYS.CURRENT}
        storeFactory={getCurrentDispatchObjectsStore}
        showTripColumns={true}
    />
);

export default CurrentTab;
